<template>
  <div v-if="contrast" class="flex space-x-3 bg-black/40 px-8 py-4 rounded shadow-lg">
    <button @click="share('facebook')" class="text-white cursor-pointer hover:text-blue-200 transition">
      <Facebook class="w-5 h-5"/>
    </button>
    <button @click="share('twitter')" class="text-white cursor-pointer hover:text-blue-200 transition">
      <X class="w-5 h-5"/>
    </button>
    <button @click="share('instagram')" class="text-white cursor-pointer hover:text-pink-200 transition">
      <Instagram class="w-5 h-5"/>
    </button>
  </div>
  <div v-else class="flex space-x-3">
    <button @click="share('facebook')" class="text-blue-600 cursor-pointer hover:text-blue-800 transition">
      <Facebook class="w-5 h-5"/>
    </button>
    <button @click="share('twitter')" class="text-gray-800 cursor-pointer hover:text-blue-600 transition">
      <X class="w-5 h-5"/>
    </button>
    <button @click="share('instagram')" class="text-pink-500 cursor-pointer hover:text-pink-700 transition">
      <Instagram class="w-5 h-5"/>
    </button>
  </div>
</template>

<script setup>

import {Facebook, Instagram, X} from "@iconoir/vue";


defineProps({
  contrast: {
    type: Boolean,
    default: false
  }
})

const share = (platform) => {
  const url = encodeURIComponent(window.location.href);
  let shareUrl = '';
  if (platform === 'facebook') {
    shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  } else if (platform === 'twitter') {
    shareUrl = `https://twitter.com/intent/tweet?url=${url}`;
  } else if (platform === 'instagram') {
    // Instagram does not support direct URL sharing. Open homepage.
    shareUrl = `https://www.instagram.com/`;
  } else {
    return;
  }

  window.open(shareUrl, '_blank');
}


</script>


<style scoped>

</style>